import React from 'react';
import { View } from 'react-native';
import { Text } from './Text';
import { useTheme } from './theme';

export interface BarDatum {
  label: string;
  value: number;
  color?: string;
}

/** Vertical column chart drawn with Views. */
export function BarChart({ data, height = 160, format = (n) => String(n) }: { data: BarDatum[]; height?: number; format?: (n: number) => string }) {
  const { colors } = useTheme();
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <View style={{ flexDirection: 'row', alignItems: 'flex-end', gap: 6, height: height + 36 }}>
      {data.map((d, i) => (
        <View key={`${d.label}-${i}`} style={{ flex: 1, alignItems: 'center', justifyContent: 'flex-end', height: '100%', gap: 4 }}>
          <Text size={10} color={colors.muted} numberOfLines={1}>
            {format(d.value)}
          </Text>
          <View accessibilityLabel={`${d.label}: ${format(d.value)}`} style={{ width: '70%', maxWidth: 42, height: Math.max(2, (d.value / max) * height), backgroundColor: d.color ?? colors.primary, borderTopLeftRadius: 4, borderTopRightRadius: 4 }} />
          <Text size={10} color={colors.muted} numberOfLines={1}>
            {d.label}
          </Text>
        </View>
      ))}
    </View>
  );
}

/** Horizontal bars (department breakdowns etc.). */
export function HBarChart({ data, format = (n) => String(n) }: { data: BarDatum[]; format?: (n: number) => string }) {
  const { colors } = useTheme();
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <View style={{ gap: 8 }}>
      {data.map((d, i) => (
        <View key={`${d.label}-${i}`} style={{ gap: 3 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text size={12}>{d.label}</Text>
            <Text size={12} weight="semibold">
              {format(d.value)}
            </Text>
          </View>
          <View style={{ height: 8, backgroundColor: colors.neutralSoft, borderRadius: 4, overflow: 'hidden' }}>
            <View style={{ width: `${(d.value / max) * 100}%`, height: '100%', backgroundColor: d.color ?? colors.primary, borderRadius: 4 }} />
          </View>
        </View>
      ))}
    </View>
  );
}
